/* eslint-disable no-nested-ternary */
import { useQuery } from '@apollo/client';
import { GET_HOSTING_PLAN } from '../../helpers/graphql/hosting';
import DashboardCard from './DashboardCard';
import HostingDashboard from './Hosting/HostingDashboard';
import AddBlogWizard from './Hosting/AddBlogWizard';
import HostingMore from './Hosting/HostingMore';
import { useState } from 'react';
import Button from '@mui/material/Button';
import CustomSnackbar from './Notifications/CustomSnackbar';
import VerifyEmail from './Hosting/VerifyEmail';

export default function Hosting({ page, paymentSuccess, blogId }) {
  const [showAddBlogWizard, setShowAddBlogWizard] = useState(false);
  const [emailVerificationComplete, setEmailVerificationComplete] = useState(
    false,
  );

  const { data, refetch } = useQuery(GET_HOSTING_PLAN, {
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  if (!data || !data.getHostingPlan) return <></>;
  if (!data.getHostingPlan.hasVerifiedEmail && !emailVerificationComplete)
    return (
      <div className="container d-flex justify-content-center mt-5 mb-5">
        <div style={{ maxWidth: '900px' }}>
          <DashboardCard
            titleSize="h5"
            title="Add your email to join hosting"
            content={
              <VerifyEmail
                setEmailVerificationComplete={setEmailVerificationComplete}
              />
            }
          />
        </div>
      </div>
    );
  let trialBlogs = 0;
  if (data.getHostingPlan.blogs && data.getHostingPlan.blogs.length > 0) {
    data.getHostingPlan.blogs.forEach(blog => {
      if (blog.plan === 'trial') trialBlogs += 1;
    });
  }
  if (
    showAddBlogWizard ||
    !data.getHostingPlan.blogs ||
    data.getHostingPlan.blogs.length === 0
  )
    return (
      <div className="container d-flex justify-content-center mt-5 mb-5">
        <div style={{ maxWidth: '900px' }} className="tw-w-full">
          <DashboardCard
            titleSize="h5"
            title={
              data.getHostingPlan.blogs && data.getHostingPlan.blogs.length > 0
                ? data.getHostingPlan.blogs.length === 1
                  ? 'Create your second blog'
                  : 'Create a new blog'
                : 'Create your blog in 1 minute'
            }
            content={
              trialBlogs > 0 ? (
                <>
                  <div className="mb-3">
                    <CustomSnackbar
                      variant="error"
                      message="You can only have a free trial for one blog at a time. Please upgrade your existing blog to a paid plan to create a new blog."
                    />
                  </div>
                  <Button
                    onClick={() => setShowAddBlogWizard(false)}
                    variant="outlined"
                  >
                    Back
                  </Button>
                </>
              ) : (
                <AddBlogWizard
                  isFirstBlog={
                    !data.getHostingPlan.blogs ||
                    data.getHostingPlan.blogs.length === 0
                  }
                  closeWizard={() => setShowAddBlogWizard(false)}
                  setShowAddBlogWizard={setShowAddBlogWizard}
                />
              )
            }
          />
        </div>
      </div>
    );
  let initialSelectedBlog = 0;
  if (data.getHostingPlan.blogs.length > 0 && blogId) {
    data.getHostingPlan.blogs.forEach((blog, i) => {
      if (blog.id === blogId) initialSelectedBlog = i;
    });
  }
  return (
    <div className="container d-flex justify-content-center mt-1 mb-5">
      <div style={{ maxWidth: '900px' }}>
        <HostingDashboard
          blogs={data.getHostingPlan.blogs}
          openBlogWizard={() => setShowAddBlogWizard(true)}
          page={page}
          paymentSuccess={paymentSuccess}
          initialSelectedBlog={initialSelectedBlog}
          refetchHostingPlan={refetch}
        />
        <HostingMore
          openBlogWizard={() => setShowAddBlogWizard(true)}
          blogNo={data.getHostingPlan.blogs.length}
        />
      </div>
    </div>
  );
}
